import styled from '@emotion/styled';
import React from 'react';

interface AutomationsHelpLinkProps {
  text: string;
}

export function AutomationsHelpLink({
  text,
  ...rest
}: AutomationsHelpLinkProps) {
  return (
    <Link
      href="https://support.hire.toggl.com/en/articles/11365413-automations"
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      {text}
    </Link>
  );
}

const Link = styled.a`
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`;
